export const toColumnIds = <T extends string>(value: unknown): T[] =>
  Array.isArray(value) ? value.filter((item): item is T => typeof item === "string") : [];

export const syncColumnsOrder = <T extends string>(
  storedConfig: { visible: T[]; hidden: T[] },
  defaultConfig: { visible: T[]; hidden: T[] }
): { visible: T[]; hidden: T[] } => {
  const knownColumns = new Set([...defaultConfig.visible, ...defaultConfig.hidden]);
  const visible = [...new Set(storedConfig.visible.filter((value) => knownColumns.has(value)))];
  const visibleSet = new Set(visible);
  const hidden = [
    ...new Set(
      storedConfig.hidden.filter((value) => knownColumns.has(value) && !visibleSet.has(value))
    ),
  ];

  defaultConfig.visible.forEach((value, index) => {
    if (!hidden.includes(value) && !visible.includes(value)) {
      visible.splice(index, 0, value);
    }
  });

  defaultConfig.hidden.forEach((value) => {
    if (!hidden.includes(value) && !visible.includes(value)) {
      hidden.push(value);
    }
  });

  const hasChanged =
    visible.length !== storedConfig.visible.length ||
    hidden.length !== storedConfig.hidden.length ||
    visible.some((value, index) => value !== storedConfig.visible[index]) ||
    hidden.some((value, index) => value !== storedConfig.hidden[index]);

  if (!hasChanged) {
    return storedConfig;
  }

  return { visible, hidden };
};
